import React from 'react';
import styled from 'styled-components';

interface AnnotationsToggleProps {
  isHidden: boolean;
  onToggle: () => void;
}

const ToggleContainer = styled.button`
  position: relative;
  height: 30px;
  width: 68px;
  border-radius: ${props => props.theme.borderRadius.full};
  overflow: hidden;
  border: none;
  cursor: pointer;
  padding: 0;
  background: transparent;
`;

const ToggleBackground = styled.div<{ $isHidden: boolean }>`
  position: absolute;
  inset: 0;
  border-radius: ${props => props.theme.borderRadius.full};
  transition: background 0.3s ease;
  background: ${props => 
    props.$isHidden 
      ? '#DBDBDB' 
      : 'linear-gradient(to bottom, #66FFED, #FFEEB2)'
  };
`;

const ToggleSlider = styled.div<{ $isHidden: boolean }>`
  position: absolute;
  top: 2.5px;
  height: 25px;
  width: 38px;
  border-radius: ${props => props.theme.borderRadius.full};
  background: ${props => 
    props.$isHidden 
      ? '#ffffff' 
      : 'linear-gradient(to bottom, #FFC123, #F8832E)'
  };
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  left: ${props => props.$isHidden ? '2.5px' : '27.5px'};
`;

const AnnotationsToggle: React.FC<AnnotationsToggleProps> = ({ isHidden, onToggle }) => {
  return (
    <ToggleContainer onClick={onToggle} aria-label={isHidden ? '메모/하이라이트 표시' : '메모/하이라이트 숨기기'}>
      <ToggleBackground $isHidden={isHidden} />
      <ToggleSlider $isHidden={isHidden} />
    </ToggleContainer>
  );
};

export default AnnotationsToggle;
